module.exports = __webpack_public_path__ + "static/media/shipForMe.ac9c4ad9.png";